import { SWITCHER_STATES } from '../../../constants';

export const EVENT_TYPE = {
    [SWITCHER_STATES.LOGO_SERVICES]: 'clicked_on_logo_design_fork',
    [SWITCHER_STATES.LOGO_MAKER]: 'clicked_on_logo_maker_fork',
};
